import { render } from "./SidebarItem.vue?vue&type=template&id=6d038e22&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=6d038e22&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d038e22"]])

export default __exports__